import { AsyncRenderer } from '../../components/AsyncRenderer/AsyncRenderer';
import { Loader } from './view/components/Loader';
import { DiscountsDetailsView } from './view/DiscountDetails.view';
import { useDiscountDetailsVM } from './view-model/discountDetails.viewModel';

type RouteParams = { influencerId: string; discountId: string };

export const PromotionsDetailsPage = (p: { params: RouteParams }) => {
  const vm = useDiscountDetailsVM(p.params.discountId);

  return (
    <AsyncRenderer
      data={vm}
      loadRender={<Loader />}
      renderer={DiscountsDetailsView}
    />
  );
};
